import { isEmpty, pick } from 'lodash-es'
import type { Comment } from '@/@types/comment'
import CommentListContent from '@/components/Comment/CommentListContent'
import type { GetCommentParams } from '@/utils/fetchers/comment'
import StoryComment from './StoryComment'

export interface StoryCommentListProps {
	data: Comment[]
	canReply: boolean
	isLoading?: boolean
	onDelete: (data: Comment) => Promise<Comment>
	onReply: (data: Comment) => void
}

export default function StoryCommentList({
	data,
	canReply,
	isLoading = false,
	onDelete,
	onReply,
}: StoryCommentListProps) {
	return (
		<CommentListContent empty={isEmpty(data)} isLoading={isLoading}>
			{data.map((comment) => (
				<StoryComment
					key={comment.id}
					canReply={canReply}
					data={pick(comment, ['id', 'targetType']) as GetCommentParams}
					onDelete={onDelete}
					onReply={onReply}
				/>
			))}
		</CommentListContent>
	)
}
